import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Grid, SvgIcon, Avatar, ListItem, ListItemText, ListItemAvatar } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: theme.palette.secondary.main,
  },
}));

function PropertyDetailsIndicativeItem({ icon, iconPath, primaryText, secondaryText, secondaryTypographyProps }) {
  const classes = useStyles();

  return (
    <Grid item xs>
      <ListItem>
        <ListItemAvatar>
          <Avatar className={classes.avatar}>
            {iconPath &&
              <SvgIcon>
                <path d={iconPath} />
              </SvgIcon>
            }
            {icon}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={primaryText}
          secondary={secondaryText}
          secondaryTypographyProps={secondaryTypographyProps}
        />
      </ListItem>
    </Grid>
  )
}

export default PropertyDetailsIndicativeItem;

